import some from 'lodash/some';
import gettext from 'js-utils/gettext';

export const getTrendingSearchesPathForLocation = (slug) =>
    `/trending/searches/${slug}/`;

const _isTrendingSearchCity = (trendingSearchCities, domain, slug) =>
    some(
        trendingSearchCities,
        (trendingSearchCity) => trendingSearchCity[1] === slug,
    );

export const getTrendingSearchData = (
    { slug, currentPlace, currentPlaceParent, trendingSearchCities },
    domain,
) => {
    let trendingSearchData = null;

    if (_isTrendingSearchCity(trendingSearchCities, domain, slug)) {
        trendingSearchData = {
            text: gettext('Trending searches in %(city)s, %(region)s', {
                city: currentPlace,
                region: currentPlaceParent,
            }),
            path: getTrendingSearchesPathForLocation(slug),
        };
    }

    return trendingSearchData;
};
